<template>
  <div class="h-full">
    <blitz-sidebar
      :visible="sidebar"
      @hide="sidebar = false"
    />
    <div class="lg:pl-64 flex flex-col flex-1">
      <blitz-header @toggle="sidebar = !sidebar" />
      <main class="flex-1">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import BlitzHeader from '../components/BlitzHeader.vue'
import BlitzSidebar from '../components/BlitzSidebar.vue'

export default {
  components: {
    BlitzHeader,
    BlitzSidebar
  },
  data () {
    return {
      sidebar: false
    }
  }
}
</script>
